const directive = {
    bind: function(el, binding) {
        let settings = binding.value;

        el.value = directive.format(settings, el.value);
        el.dispatchEvent(new Event('input'));

        let handler = function(e) {
            e.target.value = directive.format(settings, e.target.value);
            el.dispatchEvent(new Event('input')); // added this
        };

        el.addEventListener('blur', handler, true);
    },
    format(settings, value) {
        settings.step = settings.step ? parseFloat(settings.step) : 1;
        settings.stepModifier = 1 / settings.step;

        let elemValue = parseFloat(value) || 0;
        elemValue = Math.round(elemValue * settings.stepModifier) / settings.stepModifier;
        elemValue = Math.min(elemValue, settings.max);
        elemValue = Math.max(elemValue, settings.min);

        return elemValue.toFixed(1) + '°';
    },
};

export default directive;
